import { Link } from 'react-router-dom';
import { topWorks, typeLabel } from '@/mocks/catalog';

export default function TopRanking() {
  return (
    <section className="w-full bg-background-50 px-4 py-12 md:px-8 md:py-16">
      <div className="mx-auto grid w-full max-w-[1400px] grid-cols-1 gap-6 lg:grid-cols-[1fr_360px]">
        <div>
          <div className="flex flex-wrap items-end justify-between gap-3">
            <div>
              <p className="font-label text-xs uppercase tracking-[0.2em] text-accent-600">Top 10</p>
              <h2 className="mt-2 font-display text-2xl font-bold text-foreground-950 md:text-3xl">热门影视排行榜</h2>
            </div>
            <span className="flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
              <i className="ri-live-line"></i>
              按播放热度实时统计
            </span>
          </div>

          <div className="mt-6 overflow-hidden rounded-lg border border-background-200/70">
            {topWorks.map((work, index) => (
              <Link
                key={work.id}
                to={`/detail/${work.id}`}
                className="group flex items-center gap-3 border-b border-background-200/60 bg-background-50 px-3 py-3 transition-colors last:border-b-0 hover:bg-background-100 md:gap-4 md:px-4"
              >
                <span
                  className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md font-display text-sm font-bold ${
                    index < 3 ? 'bg-accent-500 text-foreground-950' : 'bg-background-200 text-foreground-600'
                  }`}
                >
                  {index + 1}
                </span>
                <div className="h-14 w-10 shrink-0 overflow-hidden rounded-md bg-background-200 md:h-16 md:w-12">
                  <img
                    src={work.poster}
                    alt={`${work.title} 海报`}
                    title={`${work.title} - 热门推荐`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="truncate text-sm font-semibold text-foreground-950 group-hover:text-accent-700">{work.title}</h3>
                  <p className="mt-1 truncate text-xs text-foreground-500">
                    {typeLabel[work.type]} · {work.genres.join(' / ')} · {work.year}
                  </p>
                </div>
                <div className="hidden shrink-0 items-center gap-6 sm:flex">
                  <span className="font-label text-xs text-foreground-500">{work.region}</span>
                  <span className="flex items-center gap-1 whitespace-nowrap font-label text-xs text-foreground-600">
                    <i className="ri-play-circle-line text-accent-600"></i>
                    {work.views}
                  </span>
                  <span className="flex w-11 items-center justify-end gap-0.5 font-label text-sm font-bold text-accent-700">
                    <i className="ri-star-fill text-[11px]"></i>
                    {work.rating.toFixed(1)}
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>

        <aside className="flex flex-col gap-4">
          <div className="rounded-lg border border-background-200/70 bg-primary-950 p-5 text-background-100">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
              <i className="ri-question-answer-line text-base"></i>
            </span>
            <h2 className="mt-3 font-display text-lg font-bold text-white">不知道看什么？</h2>
            <p className="mt-2 text-sm leading-relaxed text-background-300">
              从高分纪录片开始，或者挑一部十集以内的迷你剧。十分钟就能决定今晚的片单。
            </p>
            <Link
              to="/category/tv/list?sort=评分最高"
              className="mt-4 flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm font-bold text-foreground-950 transition-colors hover:bg-accent-400"
            >
              高分片单 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="rounded-lg border border-background-200/70 bg-background-100 p-5">
            <h2 className="font-display text-base font-bold text-foreground-950">本周话题标签</h2>
            <div className="mt-3 flex flex-wrap gap-2">
              {['年度悬疑', '慢综艺', '治愈系', '视效大片', '高分纪录片', '科技犯罪', '日剧'].map((tag) => (
                <Link
                  key={tag}
                  to={`/search?q=${encodeURIComponent(tag)}`}
                  className="rounded-full border border-secondary-200 bg-background-50 px-2.5 py-1 text-xs text-secondary-900 transition-colors hover:border-accent-400 hover:text-accent-700"
                >
                  #{tag}
                </Link>
              ))}
            </div>
            <div className="mt-5 grid grid-cols-2 gap-2 border-t border-background-300/60 pt-4">
              <div>
                <p className="font-display text-xl font-bold text-foreground-950">1,286</p>
                <p className="text-[11px] text-foreground-500">收录作品</p>
              </div>
              <div>
                <p className="font-display text-xl font-bold text-foreground-950">312</p>
                <p className="text-[11px] text-foreground-500">影视资讯</p>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
}